module.exports = __webpack_public_path__ + "img/placeholder.c646c27f.png";